import { useNavigate, useLocation } from 'react-router';

const useSearchParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const getSearchParams = () => {
    const currentSearch =
      typeof window !== 'undefined' && window.location.search ? window.location.search : search;
    return new URLSearchParams(currentSearch);
  };

  const setSearchParam = (param: string, value: string | number) => {
    const searchParams = getSearchParams();
    searchParams.set('page', '0');
    searchParams.set(param, value.toString());
    navigate({
      search: searchParams.toString(),
    });
  };

  const removeSearchParamSingle = (param: string) => {
    const searchParams = getSearchParams();
    searchParams.set('page', '0');
    searchParams.delete(param);
    navigate({
      search: searchParams.toString(),
    });
  };

  const removeSearchParamMultiple = (param: string, urlKey: string) => {
    const searchParams = getSearchParams();
    const currentUrlValues = searchParams.get(urlKey)?.split(',') || [];
    const updatedParams = currentUrlValues.filter((value) => value !== param);

    if (updatedParams.length === 0 || (updatedParams.length === 1 && updatedParams[0] === '')) {
      searchParams.delete(urlKey);
      navigate({
        search: searchParams.toString(),
      });
    } else {
      searchParams.set(urlKey, updatedParams.join(','));
      navigate({
        search: searchParams.toString(),
      });
    }
  };

  return { setSearchParam, removeSearchParamSingle, removeSearchParamMultiple };
};

export default useSearchParams;
